import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

const REGION_KEY = 'aps.region';

interface RegionValue {
  regionId: string | null;
  setRegionId: (next: string | null) => void;
}

const RegionContext = createContext<RegionValue | null>(null);

/**
 * Mijoz hududi.
 *
 * Hudud qoldiq matnini ("qayerda bor") va checkout'ni belgilaydi.
 * Tanlov eslab qolinadi — har kirishda qayta so'ralmaydi.
 */
export function RegionProvider({ children }: { children: ReactNode }): ReactNode {
  const [regionId, setState] = useState<string | null>(() => {
    try {
      return globalThis.localStorage.getItem(REGION_KEY);
    } catch {
      return null;
    }
  });

  const setRegionId = useCallback((next: string | null) => {
    setState(next);
    try {
      if (next === null) globalThis.localStorage.removeItem(REGION_KEY);
      else globalThis.localStorage.setItem(REGION_KEY, next);
    } catch {
      // Saqlab bo'lmasa ham ilova ishlaydi.
    }
  }, []);

  const value = useMemo<RegionValue>(() => ({ regionId, setRegionId }), [regionId, setRegionId]);
  return <RegionContext.Provider value={value}>{children}</RegionContext.Provider>;
}

export function useRegion(): RegionValue {
  const value = useContext(RegionContext);
  if (value === null) throw new Error('useRegion faqat RegionProvider ichida ishlaydi');
  return value;
}
